
import { addMessage } from '@/services/messages'

export default {
  props: ['index', 'person'],
  setup(props: any) {
    const talk = function() {
      addMessage(`talk ${props.index + 1}`, 'input')
    }

    return { talk }
  }
}
